import { fromJS } from 'immutable'
import {
  ACCOUNTING_PAYING_GET_REQUEST,
  ACCOUNTING_PAYING_GET_SUCCESS,
  ACCOUNTING_PAYING_GET_FAILURE,
  ACCOUNTING_PAYING_GET_RESET,
} from '../../actions/accounting-dashboard/types'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case ACCOUNTING_PAYING_GET_REQUEST:
      return state
        .set('isFetching', true)
    case ACCOUNTING_PAYING_GET_SUCCESS:
      return state
        .set('accountantPaying', fromJS(action.payload.accountantPaying))
        .set('isFetching', false)
    case ACCOUNTING_PAYING_GET_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case ACCOUNTING_PAYING_GET_RESET:
      return state
        .set('isFetching', false)
        .set('accountantBilling', null)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/accounting-dashboard/paying-get-reducer.js